import {del} from '../utils'

export default host => (id, type) => del(`${host}/files/upload/${id}/${type}`)
